<template>
	<b-overlay :show="is_load">
		<div class="categ_info" v-if="product.id > 0">

            <div class="prod_ai_image mb-5 pt-5" v-on:click="showAi">
               <!--
                <button
                    class="btn btn-md btn-block btn-outline-primary waves-effect waves-themed" >
                    <span  class="fal  fa-eject mr-1"></span>
                    {{__t('AI_IMAGE_GENERATE')}}
                </button>

                <ai_prod_image :product="product"></ai_prod_image>
                -->
            </div>

			<fileload
				@on_load="on_loading_files"
				:doc_id="product.id"
				doc_type="product"
			></fileload>
		</div>
	</b-overlay>
</template>

<script>
import Fileload from "../../../../sys/file_loader/fileload";
import Ai_prod_image from "../ai_image/ai_prod_image.vue";

export default {
	name: "product_images",
	props : {
		product : {
			type : Object
		}
	},
	components: {
        Ai_prod_image,
		Fileload
	},

	data() {
		return {
			is_loaded : false,
			is_load: false,
			my_files : []
		}
	},
	created() {

	},

	methods: {

        showAi() {
              EventBus.$emit('show_ai_image');
        },

		on_loading_files(state) {
			this.is_load = state;
		}
	},
}
</script>

<style scoped>

</style>
